export default "__VITE_ASSET__oOUVwPSz__"